import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delete-confirm-pop-up',
  templateUrl: './delete-confirm-pop-up.component.html',
  styleUrls: ['./delete-confirm-pop-up.component.scss']
})
export class DeleteConfirmPopUpComponent implements OnInit {

  isLoading: boolean = false;
  ConsultTopicForm: any;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DeleteConfirmPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService,) {
  }

  ngOnInit(): void {

  }

  actionModal(response : boolean = false) {
    this.dialogRef.close({ response : response });
  }


}
